module.exports = __webpack_public_path__ + "static/media/bem_fti_its.e559077f.png";